const initialState = {
  // viewOptionsLines: ['bts.sukhumvit', 'bts.silom', 'mrt'],
  viewOptionsLines: ['low', 'high'],
  viewOptionList: [
    'percentSold',
    'unitsLeft',
    'absorptionRateAll',
    'absorptionRateLastQ',
    'estimateTimeToDairn',
    'startingResalePrice',
    'resalePriceSqm',
    'rentalPrice',
    'rentalPriceSqm',
    'capitalGain',
    'rentalYield',
    'launchPriceSqm',
    'startingPrice',
    'startingCurrentPrice',
    'currentPriceSqm',
  ],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'DOMAIN/MAP/ANALYSIS/VIEWOPTION/LINES/CHANGE':
      return {
        ...state,
        viewOptionsLines: action.values,
      };
    case 'DOMAIN/ANALYSIS/VIEWOPTION/CHANGE':
      return {
        ...state,
        viewOptionList: action.values,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/domain/analysis.js